import { FormattedDurationSince } from '../../../../common/components/formatted-duration-since';
import { Tooltip } from '../../../../common/components/tooltip';
import { getFormattedDate } from '../../../utils/get-formatted-date';
import { BaseQueueCell } from '../../base-queue-cell';

export function MinutesCell({ date }: { date: string | undefined }): React.ReactElement {
    if (!date) {
        return <BaseQueueCell />;
    }
    return (
        <Tooltip overlay={getFormattedDate(date)}>
            <BaseQueueCell alignment="RIGHT">
                <FormattedDurationSince date={new Date(date)} color="inherit" />
            </BaseQueueCell>
        </Tooltip>
    );
}
